import { ROUTE_CHANGE_ERROR } from '@/features/shared/constants/global'

/**
 * Error messages we want to ignore globally in error monitoring.
 * Think VERY CAREFULLY before ignoring something here.
 */
export const globalIgnoredMessages: (string | RegExp)[] = [
  'Failed to fetch', // failed to fetch 3rd party resources for pinterest, tiktok, etc
  'Network Error', // Axios logs for every API error
  ROUTE_CHANGE_ERROR.message, // ignore due to manually throwing routing error
  /undefined is not an object.*(window\.webkit\.messageHandlers|window\.__firefox__\.reader)/i, // vendor JS via GTM
  /null is not an object \(evaluating 'document\.querySelector(.*)\.value = /, // script or extension filling out input fields
  "null is not an object (evaluating 'element.src')", // script or extension playing video/audio
  'Uncaught "Empty reason"',
  'Load failed',
  /Script error/, // GTM/Ad blockers
  /csp_violation/, // Ad blockers and third party scripts often cause CSP violations
  /Failed to load .*(\.pinterest\.com)/,
  // browser extension and Google translate errors
  "Failed to execute 'nextNode' on 'TreeWalker': The provided callback is no longer runnable.",
  /^Failed to set the 'textContent' property on/,
  "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
  'Could not load "(controls|marker|onion|poly)".', // Google Maps API failures
]
